import { createStyles } from "src/styles/theme";

export type StylesClasses = keyof typeof styles;

const styles = createStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100%",
    padding: "8px 0",
  },

  bar: {
    height: "6px",
    borderRadius: "3px",
  },

  stats: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    fontSize: "12px",
    color: "custom.label",
  },

  transferred: {
    fontWeight: 600,
  },

  rate: {
    whiteSpace: "nowrap",
  },
});

export default styles;
